export default __webpack_public_path__ + "static/media/survey5.418a75e4.svg";